import React from 'react';

// components
import LoadMore from '../generalComponents/LoadMore';
import { RootStoreContext } from '../../context';
import vaultImg1 from '../../assets/vault/naked-news-premium-snapchat-f726a45f.png';
import PropTypes from 'prop-types';

// constants
import { SNAPSHOTS_CDN } from '../../constants/liveCams';

import FeaturedItem from './FeaturedItem';
import FeaturedItemsHeading from './FeaturedItemsHeading';


class FeaturedItems extends React.Component {
  renderSnapchatBanner = () => (
    <div className="content-item-container main">
      <a
        className="content-item "
        href="https://fancentro.com/thenakednews"
        rel="noopener noreferrer"
        target="_blank"
        title="Naked News Premium Snapchat"
      >
        <div className="content-item-thumbnail">
          <img
            alt="Xlthumb placeholder"
            src={vaultImg1}
            style={{ opacity: 1 }}
          />
        </div>
        <div className="content-item-caption">
          <div className="content-item-category">Naked Notes</div>
          <div className="content-item-title">
            Naked News Premium Snapchat
          </div>
        </div>
      </a>
    </div>
  );

  render() {
    const {
      featuredItems,
      loadMore,
      isLoading,
      showLoadMoreButton,
      showHeading,
      type,
    } = this.props;

    const isTitleForHome = window.location.pathname;

    return (
      <div className="content">
        <div className="container">
          <FeaturedItemsHeading
            isTitleForHome={isTitleForHome}
            showHeading={showHeading}
          />
          <div className="content-grid-container">
            <div className="content-grid">
              {featuredItems.map((link, index) => (
                <FeaturedItem key={link?.name || link?.title} featuredItem={link} type={type} />
              ))}
            </div>
            {/* <div>
                            <div className="cams-title">Naked News Cams</div>
                            <div className="row live-cams-container">
                                <iframe
                                    src="https://as.sexad.net/as/if?p=nakednews&w=100&h=100&v=5186"
                                    data-src="https://as.sexad.net/as/if?p=nakednews&w=100&h=100&v=5186"
                                    align="middle"
                                    allowtransparency="true"
                                    width="100%"
                                    height="100%"
                                    marginHeight="0"
                                    marginWidth="0"
                                    frameBorder="0"
                                    scrolling="no">
                                </iframe>
                            </div>
                        </div>*/}

          </div>
          {showLoadMoreButton && (
            <LoadMore isLoading={isLoading} loadMore={loadMore} />
          )}
        </div>
      </div>
    );
  }
}

export default FeaturedItems;

FeaturedItems.propTypes = {
  featuredItems: PropTypes.array.isRequired,
  loadMore: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  showHeading: PropTypes.bool,
  showLoadMoreButton: PropTypes.bool,
  type: PropTypes.string,
};

FeaturedItems.defaultProps = {
  isLoading: false,
  showLoadMoreButton: false,
  showHeading: true,
  type: 'featured',
};
